import { Component, OnInit } from '@angular/core';
import { PendingRequest } from 'src/app/service/modal/pendingrequest';
import { ActivatedRoute } from '@angular/router';
import { MailViewService } from 'src/app/service/apiservice/mailview.service';
import { Globals } from '../../../globals';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-pending-view-mobile',
  templateUrl: './pending-view-mobile.component.html',
  styleUrls: ['./pending-view-mobile.component.css']
})
export class PendingViewMobileComponent implements OnInit {

  mailId: number;
  ViewData: PendingRequest = new PendingRequest();
  todayDate: any;

  constructor(private route: ActivatedRoute, private _mailService: MailViewService,private global:Globals) { }

  ngOnInit() {

    this.global.afterRefreshPageSetToken();
    this.route.params.subscribe(params => this.mailId = params['id']);
    console.log(this.mailId);
    this._mailService.GetCurrentMailPending(this.mailId)
      .subscribe((response) => {
        console.log(response);
        Object.assign(this.ViewData, response);
      }, error => {
         info_noti(error);
      });
    this.todayDate = new Date();
  }

  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }

}
